import { render, staticRenderFns } from "./nuevaEncuesta.vue?vue&type=template&id=10be554e&scoped=true"
import script from "./nuevaEncuesta.vue?vue&type=script&lang=js"
export * from "./nuevaEncuesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10be554e",
  null
  
)

export default component.exports